import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './CarouselNavigation.css';

const CarouselNavigation = ({ onPrevious, onNext, hasPrevious = true, hasNext = true, className = '' }) => {
  return (
    <>
      <button
        className={`carousel-nav-btn carousel-nav-prev ${className}`}
        onClick={onPrevious}
        disabled={!hasPrevious}
        aria-label="Previous item"
      >
        <ChevronLeft size={32} />
      </button>
      
      <button
        className={`carousel-nav-btn carousel-nav-next ${className}`}
        onClick={onNext}
        disabled={!hasNext}
        aria-label="Next item"
      >
        <ChevronRight size={32} />
      </button>
    </>
  );
};

export default CarouselNavigation;
